import {DeductibleType} from "./scope-my-suffix.model";

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum DeductableType {
    CLAUSE = 'CLAUSE',
    EXTENSION = 'EXTENSION',
    FLAT_PERCENTAGE = 'FLAT_PERCENTAGE',
    FLAT_VALUE = 'FLAT_PERCENTAGE',
    MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE = 'MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE',
    NO_DEDUCTIBLE='NO_DEDUCTIBLE'
}



export interface IRuleDeductableRateMySuffix {
    id?: number;
    decuctableName?: string;
    decuctableDescription?: string;
    flatPercentage?: number;
    flatValue?: number;
    minimumValue?: number;
    maximumValue?: number;
    percentage?: number;
    activeStatus?: ActiveStatus;
    ruleId?: number;
    deductableType?: DeductableType;
    deductibleType?: DeductibleType;
    applicableOn?: string;
    printEnable?: boolean;
}

export class RuleDeductableRateMySuffix implements IRuleDeductableRateMySuffix {
    constructor(
        public id?: number,
        public decuctableName?: string,
        public decuctableDescription?: string,
        public flatPercentage?: number,
        public flatValue?: number,
        public minimumValue?: number,
        public maximumValue?: number,
        public percentage?: number,
        public activeStatus?: ActiveStatus,
        public ruleId?: number,
        public deductableType?: DeductableType,
        public deductibleType?: DeductibleType,
        public applicableOn?: string,
        public printEnable?: boolean
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.printEnable = false;
        this.minimumValue = null;
        this.maximumValue = null;
        this.decuctableName = null;
    }
}
